// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"91d58d352ddad2d20939","293":"1850bc93216795d5b5e8","518":"a543f0b1a6ee13899818","779":"9c71f2c9a1b3a6f7e30c"}[chunkId] + ".js";
};